import { Component } from '@angular/core';

import { AuthService } from './../../services';

@Component({
    selector: 'app-top-bar',
    templateUrl: './app-top-bar.component.html',
    styleUrls: ['./app-top-bar.component.scss']
})
export class AppTopBarComponent {
    constructor (private authService: AuthService) {

    }

    logout() {
        this.authService.logout();
    }
}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/components/app-top-bar/app-top-bar.component.ts